// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"PatchworkGallery_imageWrapper__nnFIi","videoWrapper":"PatchworkGallery_videoWrapper__FTPx7","image":"PatchworkGallery_image__5H9s0"};